import React,{ useState } from "react";
import { Box,Stack } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import { selectAtom } from "jotai/utils";
import {
  baseAtom,
  selectEditingInterview,
  setNewInterviewOpen,
} from "../../stores/jotai/base";
import { hasPermissionCanvasWrite } from "../../stores/jotai/permissions";
import MaterialModal from "../app/material-modal";
import MaterialInterviewDetails from "./interview/material-interview-details";
import NoteAndAnalysisSection from "./notes-analysis-section";
import NoteEditorSkeletion from "./skeleton/NoteEditorSkeletion";

interface props {
  none?: boolean;
  aRandomTest: string;
}

const newInterviewOpenAtom = selectAtom(
  baseAtom,
  (base) => base.newInterviewOpen
);

export const RenderModals = (props) => {
  const [base, setBase] = useAtom(baseAtom);
  const canEditCanvas = hasPermissionCanvasWrite(base);
  const [interviewModalClosed, setInterviewModalClosed] = useState(false);
  const [newInterviewOpen] = useAtom(newInterviewOpenAtom);

  const handleInterviewEditModalClose = () => {
    setInterviewModalClosed(false);
    selectEditingInterview(setBase, false);
  };

  const handleNewInterviewModalClose = () => {
    setInterviewModalClosed(false);
    setNewInterviewOpen(setBase, false);
  };

  const requestModalClose = () => {
    setInterviewModalClosed(true);
  };

  let editingInterview = base.editingInterview;
  let hasInterview = false;

  if (
    editingInterview === false ||
    editingInterview === undefined ||
    editingInterview === null
  ) {
    editingInterview = {};
  } else {
    hasInterview = true;
  }

  return (
    <>
      <MaterialModal
        title="Interview Details"
        open={newInterviewOpen}
        handleDialogClose={handleNewInterviewModalClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minHeight: "500px",
              minWidth: "780px",
            },
          },
        }}
        setBase={setBase}
      >
        {/* //@ts-ignore */}
        <MaterialInterviewDetails
          style={{ width: "812px" }}
          interview={{}}
          import={undefined}
          showSaveAndOpenButton={false}
          existingInterview={false}
          audioImportDoneUploading={true}
          close={handleNewInterviewModalClose}
          errors={{}}
          handleErrors={() => {}}
          interviewModalClosed={interviewModalClosed}
          setInterviewModalClosed={setInterviewModalClosed}
          setBase={setBase}
          setIsOpen={props.setIsOpen}
          fromInterviewDrawer={true}
        />
      </MaterialModal>
      <MaterialModal
        title={canEditCanvas ? "Edit Interview" : "Interview Details"}
        open={hasInterview}
        handleDialogClose={requestModalClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minHeight: "500px",
              minWidth: "780px",
            },
          },
        }}
      >
        <MaterialInterviewDetails
          style={{ width: "812px" }}
          interview={editingInterview}
          showSaveAndOpenButton={false}
          existingInterview={hasInterview}
          errors={[]}
          close={handleInterviewEditModalClose}
          requestModalClose={requestModalClose}
          handleErrors={(e) => {
            alert(e);
            return true;
          }}
          interviewModalClosed={interviewModalClosed}
          setInterviewModalClosed={setInterviewModalClosed}
          setBase={setBase}
          setIsOpen={props.setIsOpen}
          fromInterviewDrawer={true}
        />
      </MaterialModal>
    </>
  );
};

export default function DiscoveryNavigation(props) {
  const { prevProps, allInterview,interview} = props;

  return (
    <>
      <RenderModals />

      <div
        style={{
          height: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Stack
            id="joy-discovery-text-editor"
            sx={{
              flex: 1,
              minHeight: 0,
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {interview === undefined ?   
            <NoteEditorSkeletion/> :
            <NoteAndAnalysisSection
            props={prevProps}
            allInterview={allInterview}
            />}
          </Stack>
        </Box>
      </div>
    </>
  );
}
